import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, Users, Clock, TrendingUp } from 'lucide-react';
import { RevenueChart } from './RevenueChart';
import { ClientAcquisition } from './ClientAcquisition';
import { SessionMetrics } from './SessionMetrics';

export function BusinessMetrics() {
  const metrics = [
    {
      label: 'Monthly Revenue',
      value: '₹45,200',
      change: '+12%',
      trend: 'up',
      icon: <DollarSign className="w-4 h-4" />
    },
    {
      label: 'Active Clients',
      value: '24',
      change: '+3',
      trend: 'up',
      icon: <Users className="w-4 h-4" />
    },
    {
      label: 'Avg. Session Value',
      value: '₹1,200',
      change: '+₹100',
      trend: 'up',
      icon: <Clock className="w-4 h-4" />
    },
    {
      label: 'Client Growth',
      value: '15%',
      change: '+2%',
      trend: 'up',
      icon: <TrendingUp className="w-4 h-4" />
    }
  ];

  return (
    <div className="space-y-6">
      {/* Quick Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {metrics.map((metric, index) => (
          <motion.div
            key={metric.label}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="theme-card p-4 relative overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-50" />
            <div className="relative">
              <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
                {metric.icon}
                <span>{metric.label}</span>
              </div>
              <div className="text-2xl font-bold">{metric.value}</div>
              <div className={`flex items-center gap-1 text-xs ${
                metric.trend === 'up' ? 'text-success' : 'text-destructive'
              } mt-1`}>
                <TrendingUp className="w-3 h-3" />
                <span>{metric.change} vs last month</span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <RevenueChart />
        <ClientAcquisition />
      </div>

      {/* Session Metrics */}
      <SessionMetrics />
    </div>
  );
}